import { LazyLoadingSectionLogger, LoggingSection } from "@multiweb/logging";
import { Event } from "../../../Global/Base/Events";
import { Localization } from "../../../OW.Remoting/Remoting/Localization";
import { registerCustomElement } from "../../UI.ElementarControls/Utils/CustomElementUtils";
import { Action } from "../Actions/Action";
import { DropDownMenu } from "./DropDownMenu";
import { DropDownMenuItem } from "./DropDownMenuItem";

const logger = LazyLoadingSectionLogger.create(LoggingSection.dropDown);

export class DropDownRadioButtons extends DropDownMenuItem {
    /** událost vyvolaná změnou hodnoty radiobuttonu */
    public radioButtonSelectionChanged: Event<string, void> = new Event<string, void>();
    /* vybraná položka */
    public selectedRadioButton: DropDownMenuItem;
    private _itemArray: DropDownMenuItem[] = [];
    private _withDefaultSelected: boolean;
    private _destDropDownMenu: DropDownMenu;

    public get isEnabled(): boolean {
        return !this.classList.contains("disabled");
    }

    public set isEnabled(val: boolean) {
        this.classList.toggle("disabled", !val);
    }

    /**
     * vytvoří a vrátí radiobutton element
     * @param items lokalizace a hodnota radiobuttonu
     * @param destDropDownMenu element, do kterého se radiobutton vloží
     * @param fnc funkce pro Action
     * @param withDefaultSelected defaultně ne/vybere první radiobutton
     */
    public static createDropDownRadioButtons(items: string[][], destDropDownMenu: DropDownMenu, fnc: () => Promise<void>, withDefaultSelected: boolean = true): DropDownRadioButtons {
        const element = new DropDownRadioButtons();
        element._initialize(items, destDropDownMenu, withDefaultSelected);
        element.action = new Action(fnc, "");
        return element;
    }

    protected override _constructor(): void {
        super._constructor();
    }

    protected _initialize(items: string[][], destDropDownMenu: DropDownMenu, withDefaultSelected: boolean): void {
        if (items && destDropDownMenu) {
            this._destDropDownMenu = destDropDownMenu;
            this._withDefaultSelected = withDefaultSelected;
            this._createThisElement(items);
        } else {
            logger.error("Items and dropdownmenu needs to be set.");
        }
    }

    protected _createThisElement(items: string[][]): void {
        for (const value of items) {
            const newItem = new DropDownMenuItem();
            newItem.action = new Action(async () => this.buttonClicked(newItem));
            Localization.getLocalizationItem(value[0]).then((locItem) => {
                newItem.setCaption(locItem.primaryText, locItem.locKey);
            });
            newItem.priority = 3;
            newItem.noCloseAfterSelect = true;
            newItem.icon = null;
            newItem.enabled = true;
            newItem.setAttribute("value", value[1]);
            this._itemArray.push(newItem);
        }

        if (this._withDefaultSelected) {
            this._itemArray[0].icon = "ui-check";
        }

        for (const item of this._itemArray) {
            this._destDropDownMenu.addItem(item);
        }
    }

    /**
     * vybere zadaný radiobutton
     * @param value hodnota radiobuttonu k vybrání
     * @param triggerEvent ne/vyvolá se událost změny radiobuttonu
     */
    public selectRadioButton(value: string, triggerEvent: boolean = true): void {
        if (this.selectedRadioButton && this.selectedRadioButton.getAttribute("value") == value)
            return;

        for (const item of this._itemArray) {
            if (item.getAttribute("value").toLowerCase() == value.toLowerCase()) {
                item.icon = "ui-check";
                this.selectedRadioButton = item;
            } else {
                item.icon = null;
            }
        }
        if (triggerEvent)
            this.radioButtonSelectionChanged.trigger(value, null);
    }

    private buttonClicked(dItem: DropDownMenuItem): void {
        if (this.selectedRadioButton && this.selectedRadioButton.getAttribute("value") == dItem.getAttribute("value"))
            return;
        for (const item of this._itemArray) {
            if (item == dItem && (item.enabled == true)) {
                item.icon = "ui-check";
                this.selectedRadioButton = item;
                this.radioButtonSelectionChanged.trigger(item.getAttribute("value"), null);
            } else {
                item.icon = null;
            }
        }
    }

    public disableOtherButtonsThen(enabledItemValue: string): void {
        for (const item of this._itemArray) {
            if (!(item.getAttribute("value").toLowerCase() == enabledItemValue.toLowerCase())) {
                this.disableItem(item);
            }
        }
    }

    public enableAllButtons(): void {
        for (const item of this._itemArray) {
            this.enableItem(item);
        }
    }

    public enableItem(item: DropDownMenuItem): void {
        item.enabled = true;
        item.classList.remove("disabled");
    }

    public disableItem(item: DropDownMenuItem): void {
        item.enabled = false;
        item.classList.add("disabled");
    }

    protected override _createElement(): void {
        // Prazdna metoda
    }

    protected override _setListener(): void {
        // Prazdna metoda
    }

    public finalyDispose(): void {
        this.unregisterEventListener();

        for (const element of this._itemArray) {
            element.unregisterEventListener();
            element.dispose();
        }
    }

    public override dispose(): void {
        super.dispose();
    }
}

registerCustomElement("tsc-DropDownRadioButtons", DropDownRadioButtons);
